'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.race = exports.call = exports.put = undefined;
exports.getSaga = getSaga;

var _reduxSaga = require('redux-saga');

var _debug = require('../utils/debug');

var _hooks = require('./hooks');

var fork = _reduxSaga.effects.fork,
    put = _reduxSaga.effects.put,
    call = _reduxSaga.effects.call,
    select = _reduxSaga.effects.select,
    race = _reduxSaga.effects.race;


var effectHooks = (0, _hooks.getHooks)('onEffect');
var globalErrorHandlers = (0, _hooks.getHooks)('onEffectError');

function ourPut(actionType, payload, meta) {
  var action = actionType;
  if (typeof actionType === 'string') {
    action = {
      type: actionType, payload: payload, meta: meta
    };
  }

  return put(action);
}

function applyOnEffect(fns, effect, moduleName, action) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = fns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var fn = _step.value;

      effect = fn(effect, _reduxSaga.effects, moduleName, action);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return effect;
}

function createSagaWithCatch(effect, moduleName, action) {
  return (/*#__PURE__*/regeneratorRuntime.mark(function effectWithCatch() {
      var _args = arguments;
      return regeneratorRuntime.wrap(function effectWithCatch$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return effect.apply(undefined, _args);

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

              // switch to another context, or it will be catched by redux-saga
              setTimeout(function () {
                // 没有 handler，直接抛出异常
                if (globalErrorHandlers.length <= 0) {
                  throw _context.t0;
                }

                (0, _debug.warning)('\u53D1\u73B0\u6A21\u5757 ' + moduleName + ' \u7684 ' + action.type + ' \u4E2D\u6709\u62A5\u9519\uFF0C\u4F46\u7531\u4E8E\u4F60\u5B9A\u4E49\u4E86 globalEffectErrorHandler\uFF0C\u6B64 Error \u4E0D\u4F1A\u88AB\u629B\u51FA\uFF0C\u8BF7\u81EA\u884C\u5224\u65AD\u6B64 Error \u5982\u4F55\u5982\u7406\uFF1A', _context.t0);

                (0, _hooks.execHook)('onEffectError', _context.t0, moduleName, action);
              });

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, effectWithCatch, this, [[0, 5]]);
    })
  );
}

function getEffectSaga(effectArray) {
  return (/*#__PURE__*/regeneratorRuntime.mark(function effectSaga(action) {
      var _this = this;

      var sagas, _loop, i, l;

      return regeneratorRuntime.wrap(function effectSaga$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              sagas = [];
              _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i, l) {
                var effect, moduleName, getState, moduleState, sagaWithCatch, sagaWithCatchAndOnEffect;
                return regeneratorRuntime.wrap(function _loop$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        effect = effectArray[i];
                        moduleName = effectArray[i].moduleName;

                        getState = function getState() {
                          return select(function (state) {
                            return moduleName.split('/').reduce(function (ret, name) {
                              return ret[name];
                            }, state);
                          });
                        };

                        _context2.next = 5;
                        return getState();

                      case 5:
                        moduleState = _context2.sent;
                        sagaWithCatch = createSagaWithCatch(effect, moduleName, action);
                        sagaWithCatchAndOnEffect = applyOnEffect(effectHooks, sagaWithCatch, moduleName, action);

                        // effect执行的地方，一个 effect 报错会导致所有 effect 执行中止

                        sagas.push(sagaWithCatchAndOnEffect(action, { put: ourPut, call: call, race: race, getState: getState, select: select }, moduleState));

                      case 9:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _loop, _this);
              });
              i = 0, l = effectArray.length;

            case 3:
              if (!(i < l)) {
                _context3.next = 8;
                break;
              }

              return _context3.delegateYield(_loop(i, l), 't0', 5);

            case 5:
              i++;
              _context3.next = 3;
              break;

            case 8:
              _context3.next = 10;
              return sagas;

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, effectSaga, this);
    })
  );
}

function getWatcher(actionType, effectArray) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'takeEvery';

  // console.log('effectArray', effectArray)
  return (/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(type === 'takeLatest')) {
                _context4.next = 5;
                break;
              }

              _context4.next = 3;
              return (0, _reduxSaga.takeLatest)(actionType, getEffectSaga(effectArray));

            case 3:
              _context4.next = 7;
              break;

            case 5:
              _context4.next = 7;
              return (0, _reduxSaga.takeEvery)(actionType, getEffectSaga(effectArray));

            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee, this);
    })
  );
}

function getSaga(effects) {
  // normalize effects here
  // const normalizedEffects = normalizeEffects(effects)

  return (/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var actionType, watcher;
      return regeneratorRuntime.wrap(function _callee2$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = regeneratorRuntime.keys(effects);

            case 1:
              if ((_context5.t1 = _context5.t0()).done) {
                _context5.next = 8;
                break;
              }

              actionType = _context5.t1.value;
              watcher = getWatcher(actionType, effects[actionType].effect, effects[actionType].type);
              _context5.next = 6;
              return fork(watcher);

            case 6:
              _context5.next = 1;
              break;

            case 8:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee2, this);
    })
  );
}

exports.put = ourPut;
exports.call = call;
exports.race = race;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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